
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewSidebarComponent } from './review-sidebar.component';
import { CardModule } from '../card/card.module';
import { RouterModule } from '@angular/router';
import { ListModule } from '@app/shared/ux/lists/list.module';

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        RouterModule,
        ListModule
    ],
    exports: [
        ReviewSidebarComponent
    ],
    declarations: [
        ReviewSidebarComponent
    ],
    providers: []
})
export class ReviewSidebarModule {
}
